export type BuildingProtectionStatus = 'protected' | 'not-protected' | 'unknown'

interface BuildingProtectionSource {
  protected_rank?: number | null
  protected_information_json?: Record<string, unknown> | null
  buildings_administrative?: Array<{
    protected?: boolean | null
  }> | null
}

/**
 * Resolve heritage protection from the current building-level rank, with
 * fallbacks for enriched and legacy building payloads.
 */
export const getBuildingProtectionStatus = (
  building: BuildingProtectionSource
): BuildingProtectionStatus => {
  if (
    building.protected_rank !== null &&
    building.protected_rank !== undefined
  ) {
    return building.protected_rank > 0 ? 'protected' : 'not-protected'
  }

  if (building.protected_information_json) {
    return 'protected'
  }

  const legacyStatuses = building.buildings_administrative
    ?.map((administrative) => administrative.protected)
    .filter(
      (status): status is boolean => status !== undefined && status !== null
    )

  if (legacyStatuses?.some(Boolean)) return 'protected'
  if (legacyStatuses?.length) return 'not-protected'

  return 'unknown'
}
